<template>
	
	<div>

		<v-file-input ref="fileInput" label="Select image" outlined dense></v-file-input>

		<v-btn class="ml-9 mt-n4" small @click="uploadFile">Upload</v-btn>

		<v-progress-linear class="mb-9 mt-5" v-model="uploadProgress" value="0"></v-progress-linear>

	</div>

	<!-- <v-text-field
		
		:label="field.template.name"
		v-model="field.value"
		outlined
		dense
	></v-text-field> -->

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import agile from "@/shift/agile";
import fb from '@/shift/fb';


export default
{
	name: 'ContentFieldSimpleFile',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		uploadProgress: 0,
		chosenFile: null,
		imagePath: '',
	}),



	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		if (this.field.data)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
			}
			
		}


		//https://firebasestorage.googleapis.com/v0/b/agile-shift-genesis.appspot.com/o/SunCloud.jpg?alt=media
	},

	mounted()
	{
		this.$refs.fileInput.$on('change', this.onFileChosen);
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		onFileChosen(file)
		{
			this.chosenFile = file;
		},

		uploadFile()
		{
			this.imagePath = 'content/'+this.field.actualId+'/'+this.chosenFile.name;
			const storageRef = fb.storage.ref(this.imagePath);
			const task = storageRef.put(this.chosenFile);
			task.on('state_changed', this.onProgress, this.onError, this.onComplete);
		},


		onProgress(snapshot)
		{
			const percent = (snapshot.bytesTransferred / snapshot.totalBytes)*100;
			this.uploadProgress = percent;
		},

		onError(err)
		{
			console.log('File upload error:', err);
		},

		onComplete()
		{
			this.field.value = this.imagePath;
			console.log('Complete!');
		},



	},


	beforeDestroy()
	{
		this.$refs.fileInput.$on('change', this.onFileChosen);
	},

}

</script>

